/**
*
* File is used to provide basic functionality for view
*
*/
import {user} from '../../core/controllers/user'

var SignupHelper = Class.create({
    initialize: function() {
        jQuery(document).ready(function(e) {
            // #  Setup page
            jQuery(".content").css({
                "padding": "0",
                "margin": "0"
            });
        });

        this.referralLink = null;
	},
    checkEmail: function(callback){
        var email = jQuery("#email").val();

        user.checkEmail(email, this.handleResults, callback);
    },
    createUser: function(userData, callback) {
        user.signUpUser(userData, this.referralLink, callback);
    },
    confirmUser: function(token, callback) {
        user.confirmUser(token, callback);
    },
    savePassword: function(data, type, callback) {
        var pass1 = jQuery("#password").val();
        var pass2 = jQuery("#repassword").val();

        if(pass1 !== pass2 || pass1.length == 0 || pass2.length == 0) {
            jQuery(".login-box-msg").html('Passwords do not match.');
        } else {
            jQuery(".login-box-msg").html('');
            var email = '';
            var id = '';
            if(type == 'tenant') {
                email = data.tenant_email;
                id = data.tenant_data_id;
            } else {
                email = data.email;
                id = data.user_id;
            }
            user.savePassword(email, pass1, id, type, this.handleResults, callback);
        }
    },
    createPasswordWithoutValidation: function(data, callback) {
        user.createPassword(data, callback);
    },
    handleResults: function(response, callback){
        if(!response.data){
            jQuery(".login-box-msg").html('Seems we can\'t find this email.  Public sign ups are closed for beta.');
        } else {
            jQuery(".login-box-msg").html('');
            callback(response.data, response.account_type);
        }
    },
    forgotPassword: function(email, callback) {
        user.forgotPassword(email, callback);
    },
    resetPassword: function(data, callback) {
        user.resetPasswordWithoutValidation(data, callback);
    },
    setReferralLink: function(referralLink){
        this.referralLink = referralLink;
    }
});

export let signupHelper = new SignupHelper();


// WEBPACK FOOTER //
// app/helpers/Signup/index.js